import {api} from 'api/setup';
import {IBannersRequest, IBannersResponse} from 'types';

const BASE_PATH = 'landing-banners';

export const getBanners = (params: IBannersRequest, locale?: string): Promise<IBannersResponse[]> => {
  return api.get(`/${BASE_PATH}`, {
    params,
    headers: locale ? {'Accept-Language': locale} : undefined,
  });
};
